export interface EncryptedMessage {
  ephemeralPublicKey: string;
  iv: string;                 
  encryptedMessage: string; 
}

export interface EncryptedMessage {
  ephemeralPublicKey: string; 
  iv: string;                 
  encryptedMessage: string;   
}

export function base64UrlToBase64(base64url: string): string {

  let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) {
    base64 += '=';
  }
  return base64;
}

 export function base64ToUint8Array(base64: string): Uint8Array {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

export async function decryptMessage(
  msg: EncryptedMessage,
  privateKeyRaw: ArrayBuffer
): Promise<string> {
  try {


    const ephemeralPublicKeyB64 = base64UrlToBase64(msg.ephemeralPublicKey);
    const ivB64 = base64UrlToBase64(msg.iv);
    const encryptedMessageB64 = base64UrlToBase64(msg.encryptedMessage);

    const ephemeralPubBuf = base64ToUint8Array(ephemeralPublicKeyB64);
    const iv = base64ToUint8Array(ivB64);
    const ciphertext = base64ToUint8Array(encryptedMessageB64);



    if (iv.length !== 12) {
      throw new Error(`Invalid IV length. Expected 12 bytes, got ${iv.length}`);
    }

    if (ephemeralPubBuf.length !== 65) {
      throw new Error(`Invalid ephemeral public key length. Expected 65 bytes, got ${ephemeralPubBuf.length}`);
    }


    const ephemeralPublicKey = await crypto.subtle.importKey(
      'raw',
      ephemeralPubBuf,
      { name: 'ECDH', namedCurve: 'P-256' },
      true,
      []
    );


    const privateKey = await crypto.subtle.importKey(
      'pkcs8',
      privateKeyRaw,
      { name: 'ECDH', namedCurve: 'P-256' },
      false,
      ['deriveBits']
    );


    const sharedSecret = await crypto.subtle.deriveBits(
      {
        name: 'ECDH',
        public: ephemeralPublicKey,
      },
      privateKey,
      256 
    );


    const aesKeyMaterial = await crypto.subtle.digest("SHA-256", sharedSecret);
    const aesKey = await crypto.subtle.importKey(
      'raw',
      aesKeyMaterial,
      { name: 'AES-GCM' },
      false,
      ['decrypt']
    );

 
    const decrypted = await crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv,
      },
      aesKey,
      ciphertext
    );

    const decoder = new TextDecoder();
    const plaintext = decoder.decode(decrypted);
    
    return plaintext;
  } catch (error) {
    console.error("Decryption error details:", { ...msg, error });
    throw error;
  }
}

